@if (loaded) {
    <div [hidden]="!tabActive">
        <ng-content></ng-content>
    </div>
}
